import { t } from "@lingui/macro";
import { useTheme } from "@reactive-resume/hooks";
import { Label, Switch } from "@reactive-resume/ui";
import Prism from "prismjs";
import { Helmet } from "react-helmet-async";
import CodeEditor from "react-simple-code-editor";

import { useResumeStore } from "@/client/stores/resume";

import { SectionIcon } from "../shared/section-icon";
import { ReactNode } from "react";
import { CollapsibleSection } from "../../CollapsibleSection";

export const CssSection = () => {
  const { isDarkMode } = useTheme();

  const setValue = useResumeStore((state) => state.setValue);
  const css = useResumeStore((state) => state.resume.data.metadata.css);

  const headerHTML: ReactNode = (
    <div className="flex items-center gap-x-4">
      <SectionIcon id="css" size={18} name={t`Custom CSS`} />
      <h2 className="line-clamp-1 text-base font-bold lg:text-lg">{t`Custom CSS`}</h2>
    </div>
  );

  const contentHTML: ReactNode = (
    <main className="space-y-4">
      <div className="flex items-center gap-x-4">
        <Switch
          id="metadata.css.visible"
          checked={css.visible}
          onCheckedChange={(checked) => {
            setValue("metadata.css.visible", checked);
          }}
        />
        <Label htmlFor="metadata.css.visible">{t`Apply Custom CSS`}</Label>
      </div>

      <div className="rounded border p-4">
        <CodeEditor
          tabSize={4}
          value={css.value}
          className="language-css font-mono"
          highlight={(code) => Prism.highlight(code, Prism.languages.css, "css")}
          onValueChange={(value) => {
            setValue("metadata.css.value", value);
          }}
        />
      </div>
    </main>
  );

  return <CollapsibleSection id={"css"} header={headerHTML} content={contentHTML} />;
};
